import { LEGISLATION } from 'constants/controllers'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import url from 'libraries/front-end-core/core/url'

export default new Controller({
  name: 'LegacyLegislationContentRedirect',
  route: ':aol/(:archive/)legislation/*path(/edit/:editingId)',
  controller (Router, { params }) {
    const target = url(LEGISLATION, params)
    replaceUrl(target)
  }
})
